import {
    requestFamilyBookingList,
} from '../services/CustomizationAPIHelper';

const defaultState = () => ({
    familyBookingUrl: null,
    bookingAccess: null,
});

export default {
    namespace: 'customization',
    state: {
        ...defaultState(),
    },
    reducers: {
        updateState(state, { payload }) {
            return { ...state, ...payload };
        },
        clearState() {
            return defaultState();
        },
    },
    effects: {
        *getFamilyBookingList({ payload }, { call, put, select }) {
            const uid = yield select((state) => state.users.userInfo.uid);
            const response = yield call(requestFamilyBookingList, {
                userId: uid,
            });
            if (response && response.status < 300) {
                console.log("getFamilyBookingList:", response.data)
                const bookListUrl = response.data.family_booking_list_url
                const access = response.data.access
                yield put({
                    type: 'updateState',
                    payload: {
                        familyBookingUrl: bookListUrl,
                        bookingAccess: access,
                    },
                });
            }
        },
    }
};
